import { useCallback } from "react";

const SUPABASE_STORAGE_BASE =
  "https://vvzldbpwpccdljyhgssa.supabase.co/storage/v1/object/public";

const UI_SOUNDS = {
  BUTTON_CLICK: `${SUPABASE_STORAGE_BASE}/app-audio/button_click.mp3`,
  CORRECT_CHIME: `${SUPABASE_STORAGE_BASE}/app-audio/correct_chime.mp3`,
  INCORRECT_BUZZ: `${SUPABASE_STORAGE_BASE}/app-audio/incorrect_buzz.mp3`,
};

export function useUISounds() {
  const playSound = useCallback((soundUrl) => {
    if (!soundUrl) return;

    try {
      const audio = new Audio(soundUrl);
      audio.play().catch((error) => {
        console.warn("Could not play UI sound:", error);
      });
    } catch (error) {
      console.warn("Error creating audio for UI sound:", error);
    }
  }, []);

  const playButtonClick = useCallback(() => {
    playSound(UI_SOUNDS.BUTTON_CLICK);
  }, [playSound]);

  const playCorrectChime = useCallback(() => {
    playSound(UI_SOUNDS.CORRECT_CHIME);
  }, [playSound]);

  const playIncorrectBuzz = useCallback(() => {
    playSound(UI_SOUNDS.INCORRECT_BUZZ);
  }, [playSound]);

  return {
    playButtonClick,
    playCorrectChime,
    playIncorrectBuzz,
  };
}
